import React, { useState, useRef, useEffect } from 'react'
import './styles/UserProfile.css'
import CloseIcon from '@mui/icons-material/Close';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { Oval } from 'react-loader-spinner';
import EditIcon from '@mui/icons-material/Edit';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import { formatCreatedAtDate } from '../utils/datetime';
import { uploadProfilePicture, changeDisplayName, getUserEvents, changeUserBio, getExerciseTypes, changeUserPreferences } from '../api/UserAPI';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';
import DoneIcon from '@mui/icons-material/Done';
import { getAllEventsCoverImages, getEventById } from '../api/EventsAPI';
import { useModal } from '../contexts/ModalContext';
import logo from '../assets/newro-beige-logo.svg'
import { useNavigate } from 'react-router';

export default function UserProfile({ handleClose }) {
    const { user, reloadUser } = useAuth();
    const { openModal } = useModal();
    const navigate = useNavigate();

    const [displayNameInEditMode, setdisplayNameInEditMode] = useState(false);
    const [displayName, setdisplayName] = useState('');
    const [displayNameUpdateLoading, setdisplayNameUpdateLoading] = useState(false);

    const [bioInEditMode, setbioInEditMode] = useState(false);
    const [userBio, setuserBio] = useState('');
    const [userBioLoading, setuserBioLoading] = useState(false);
    const [userAvatarLoading, setuserAvatarLoading] = useState(false);
    const [resolvedAvatarUrl, setResolvedAvatarUrl] = useState(null);

    const [userEvents, setuserEvents] = useState([]);
    const [userEventsLoading, setuserEventsLoading] = useState(false);
    const [eventIndexLoading, seteventIndexLoading] = useState(-1);//index of the event that is currently being loaded for cover image else -1

    const [exerciseTypes, setExerciseTypes] = useState([]);
    const [vibe, setVibe] = useState(JSON.parse(localStorage.getItem('userData'))?.vibe || '');
    const [favouriteExercise, setFavouriteExercise] = useState(JSON.parse(localStorage.getItem('userData'))?.favouriteExercise || '');

    const vibeDisplayMap = {
        serious: { label: 'Serious', icon: <EmojiEventsOutlinedIcon sx={{ fontSize: '18px' }} /> },
        balanced: { label: 'Balanced', icon: <FavoriteOutlinedIcon sx={{ fontSize: '18px' }} /> },
        fun: { label: 'Fun', icon: <SentimentVerySatisfiedOutlinedIcon sx={{ fontSize: '18px' }} /> },
    };

    async function resolveAvatarUrl() {
        const storagePath = JSON.parse(localStorage.getItem('userData'))?.photoURL;
        if (storagePath) {
            try {
                const url = await getDownloadURL(ref(storage, storagePath));
                setResolvedAvatarUrl(url);
                return;
            } catch {}
        }
        setResolvedAvatarUrl(user.photoURL || null);
    }

    useEffect(() => {
        resolveAvatarUrl();
        getExerciseTypes().then(res => { if (res.success) setExerciseTypes(res.exerciseTypes); });
    }, []);

    async function getUserJoinedEvents() {
        // setuserEventsLoading(true)
        // const res = await getUserEvents(user.uid)
        // const enrichedEvents = await getAllEventsCoverImages(res);
        // setuserEvents(enrichedEvents)
        // setuserEventsLoading(false)
    }

    const handleLogout = async (e) => {
        try {
            await signOut(auth);
            handleClose()
        } catch (err) {
            console.log(err.message);
        }
    };

    const name = user.displayName || "New User"
    const email = user.email || "undefined"
    const avatarUrl = resolvedAvatarUrl || user.photoURL || "undefined"
    const userData = JSON.parse(localStorage.getItem('userData'));
    const joinedDate = userData.createdAt
    const bio = userData.bio
    const userIsTrainer = userData.isTrainer === true || false

    const fileInputRef = useRef(null); //for file picker (profile pic)

    const handleButtonClick = () => {
        fileInputRef.current.click(); // Open file picker
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setuserAvatarLoading(true);
            try {
                const url = await uploadProfilePicture(file, user);
                if (url) {
                    setTimeout(async () => {
                        await reloadUser();
                        await resolveAvatarUrl();
                        setuserAvatarLoading(false);
                    }, 3000); // Wait 3 seconds
                    openModal("alert", {
                        alertProps: { type: 2, message: "Profile photo updated successfully!" },
                    });
                } else {
                    throw new Error("Error");
                }
            } catch (err) {
                setuserAvatarLoading(false);
                openModal("alert", {
                    alertProps: { type: 0, message: "Request error, please try again." },
                });
            }
        }
    };

    const handleDisplayNameUpdate = async () => {
        setdisplayNameUpdateLoading(true)
        const res = await changeDisplayName(displayName, user)
        if (res.success) {
            setdisplayNameInEditMode(false)
            openModal("alert", {
                alertProps: { type: 2, message: "Display name updated successfully!" },
            });
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Request error, please try again." },
            });
        }
        setdisplayNameUpdateLoading(false)
    };

    const handleUserBioUpdate = async () => {
        setuserBioLoading(true)
        const res = await changeUserBio(userBio, user.uid)
        if (res.success) {
            let userData = JSON.parse(localStorage.getItem('userData'));
            userData.bio = userBio
            localStorage.setItem('userData', JSON.stringify(userData))
            setbioInEditMode(false)
            openModal("alert", {
                alertProps: { type: 2, message: "Bio updated successfully!" },
            });
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Request error, please try again." },
            });
        }
        setuserBioLoading(false)
    };

    const handleVibeUpdate = async (value) => {
        const res = await changeUserPreferences(user.uid, { vibe: value });
        if (res.success) {
            setVibe(value);
            openModal('alert', { alertProps: { type: 2, message: 'Vibe updated!' } });
        }
        return res;
    };

    const handleExerciseUpdate = async (value) => {
        const res = await changeUserPreferences(user.uid, { favouriteExercise: value });
        if (res.success) {
            setFavouriteExercise(value);
            openModal('alert', { alertProps: { type: 2, message: 'Favourite exercise updated!' } });
        }
        return res;
    };

    function animateEditPictureElement(operationType) {
        let elem2 = document.getElementById('add-picture-element');
        if (operationType === 'leave') {
            elem2.style.animation = 'spinOut 0.2s forwards';
        } else {
            elem2.style.animation = 'spinIn 0.2s forwards';
        }
    }
    function animateEditIcon(operationType) {
        if (displayNameInEditMode) return
        let elem2 = document.getElementById('display-name-edit-icon');
        if (operationType === 'leave') {
            elem2.style.color = 'transparent';
        } else {
            elem2.style.color = 'var(--color-primary)';
        }
    }


    async function openEventModal(event, index) {
        seteventIndexLoading(index) //display laoder for the specific event
        let eventData = {}
        const res = await getEventById(event.id);
        if (res.success) {
            eventData = { ...event, ...res.eventData }
            openModal('event', { eventData: { ...eventData } });
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Error fetching event data, please try again." },
            });
        }
        seteventIndexLoading(-1) // Reset loading state after opening modal
    }


    function handleOpenTrainerConsole() {
        navigate('/connect/console/' + user.uid)
        handleClose()
    }

    return (
        <div className='backdrop' onClick={handleClose}>
            <div className='profile-modal-body' onClick={(e) => e.stopPropagation()} >
                <div className="profile-top">
                    <div className="company-branding">
                        <div className="company-logo">
                            <img src={logo} />
                        </div>
                        <span className="company-name">newro</span>
                    </div>

                    <button className="back-button" onClick={handleClose}>
                        <CloseIcon sx={{ fontSize: '20px', color: 'var(--color-secondary)' }} />
                    </button>
                </div>
                <div className="card-content">
                    <div onClick={() => handleButtonClick()} id='avatar-container' className="avatar" onMouseEnter={() => animateEditPictureElement('enter')} onMouseLeave={() => animateEditPictureElement('leave')}>
                        {userAvatarLoading ?
                            <Oval
                                visible={true}
                                height="30px"
                                width="30px"
                                color="#ffffff"
                                strokeWidth={4}
                                ariaLabel="oval-loading"
                                wrapperStyle={{ margin: '0px' }}
                                wrapperClass=""
                            /> :
                            (avatarUrl !== 'undefined' ?
                                // <img id='div1' src={avatarUrl} alt={name} className="avatar-image" />
                                <img id='div1' src={`${avatarUrl}?t=${Date.now()}`} alt={name} className="avatar-image" />
                                : <div id='div1' className="avatar-fallback">{name.charAt(0)}</div>
                            )
                        }
                        <div id='add-picture-element' className="add-picture-clickable">
                            <CameraAltOutlinedIcon sx={{ fontSize: '27px' }} />
                            <input
                                type="file"
                                accept="image/*"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                style={{ display: "none" }} // Hide the input
                            />
                        </div>
                    </div>
                    <div className="user-info" onMouseEnter={() => animateEditIcon('enter')} onMouseLeave={() => animateEditIcon('leave')}>
                        {displayNameInEditMode ?
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <CloseIcon className='clickable-icon' onClick={() => setdisplayNameInEditMode(false)} sx={{ fontSize: '21px', margin: '7px 6px 0px 3px' }} />
                                <input className="displayname-input" value={displayName} onChange={(e) => setdisplayName(e.target.value)} />
                                {displayNameUpdateLoading ?
                                    <Oval
                                        visible={true}
                                        height="21px"
                                        width="21px"
                                        color="#4fa94d"
                                        strokeWidth={4}
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{ margin: '7px 0px 6px 3px' }}
                                        wrapperClass=""
                                    />
                                    : <DoneIcon onClick={handleDisplayNameUpdate} className='clickable-icon' sx={{ fontSize: '21px', margin: '7px 0px 6px 3px' }} />
                                }
                            </div>
                            :
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <div style={{ width: '18px', marginRight: '9px' }}>
                                </div>
                                <h2 className="name">{name}</h2>
                                <EditIcon className='clickable-icon' onClick={() => [setdisplayName(name), setdisplayNameInEditMode(true)]} id='display-name-edit-icon' sx={{ color: 'transparent', marginLeft: '9px', fontSize: '18px' }} />
                            </div>
                        }
                        <p className="title">{email}</p>
                        <p className="playing-since-badge">{"Playing since: " + formatCreatedAtDate(joinedDate)}</p>
                    </div>
                    <div className="user-info details" style={{ borderRadius: '8px' }}>
                        <div className='row'>
                            <p className="header">{'My Story'}</p>
                            {bioInEditMode ?
                                <div style={{ display: 'flex' }}>
                                    <CloseIcon className='clickable-icon' onClick={() => setbioInEditMode(false)} sx={{ fontSize: '20px', marginRight: '10px' }} />
                                    {userBioLoading ?
                                        <Oval
                                            visible={true}
                                            height="20px"
                                            width="20px"
                                            color="#4fa94d"
                                            strokeWidth={4}
                                            ariaLabel="oval-loading"
                                            wrapperStyle={{ margin: '0px 10px 0px 0px' }}
                                            wrapperClass=""
                                        />
                                        : <DoneIcon onClick={handleUserBioUpdate} className='clickable-icon' sx={{ fontSize: '20px', marginRight: '10px' }} />
                                    }
                                </div>
                                :
                                <EditIcon className='clickable-icon' onClick={() => [setuserBio(bio), setbioInEditMode(true)]} sx={{ color: 'var(--color-primary)', fontSize: '20px', marginRight: '10px' }} />
                            }
                        </div>
                        {bioInEditMode ?
                            <textarea placeholder='...tell the world what you would like them to know...' className='description' value={userBio} onChange={(e) => setuserBio(e.target.value)} disabled={!bioInEditMode}
                                style={{ resize: 'none', width: 'calc(100% - 32px)' }}></textarea>
                            :
                            <p className="description" style={{ color: bio?.length > 0 ? 'black' : 'gray' }}>{bio?.length > 0 ? bio : '...tell the world what you would like them to know...'}</p>
                        }
                    </div>
                    {/* <div className="user-info details" style={{ borderRadius: '8px' }}>
                        <div className='row'>
                            <p className="header">{'My Events/Meets'}</p>
                        </div>
                        {!userEventsLoading &&
                            <div className='user-events-display-container'>
                                {userEvents.length > 0 ? (
                                    userEvents.map((event, index) => {
                                        return (
                                            <button onClick={() => openEventModal(event, index)} key={index} className='image-icon-button'>
                                                {eventIndexLoading === index &&
                                                    <Oval
                                                        visible={true}
                                                        height="21px"
                                                        width="21px"
                                                        color="#ffffff"
                                                        secondaryColor='var(--color-primary)'
                                                        strokeWidth={4}
                                                        ariaLabel="oval-loading"
                                                        wrapperStyle={{ margin: '0px', position: 'absolute' }}
                                                        wrapperClass=""
                                                    />
                                                }
                                                <img className='image-icon' src={event.coverImageUrl} />
                                            </button>
                                        );
                                    })
                                ) : (
                                    <p className="no-events-text">No Events</p>
                                )}
                            </div>
                        }
                    </div> */}
                    <div className="preferences-row">
                        <div className="user-info details" style={{ borderRadius: '8px' }}>
                            <div className='row'>
                                <p className="header">My Vibe</p>
                                <EditIcon className='clickable-icon' onClick={() => openModal('editPreference', { type: 'vibe', currentValue: vibe, onSave: handleVibeUpdate })} sx={{ color: 'var(--color-primary)', fontSize: '20px', marginRight: '10px' }} />
                            </div>
                            <div className="preference-value">
                                {vibe ? (
                                    <>
                                        <span className="preference-icon">{vibeDisplayMap[vibe]?.icon}</span>
                                        <span>{vibeDisplayMap[vibe]?.label || vibe}</span>
                                    </>
                                ) : (
                                    <span style={{ color: 'gray' }}>Not set yet</span>
                                )}
                            </div>
                        </div>
                        <div className="user-info details" style={{ borderRadius: '8px' }}>
                            <div className='row'>
                                <p className="header">Favourite Exercise</p>
                                <EditIcon className='clickable-icon' onClick={() => openModal('editPreference', { type: 'exercise', currentValue: favouriteExercise, onSave: handleExerciseUpdate, exerciseTypes })} sx={{ color: 'var(--color-primary)', fontSize: '20px', marginRight: '10px' }} />
                            </div>
                            <div className="preference-value">
                                {favouriteExercise ? (
                                    <span>{exerciseTypes.find(et => et.id === favouriteExercise)?.name || favouriteExercise}</span>
                                ) : (
                                    <span style={{ color: 'gray' }}>Not set yet</span>
                                )}
                            </div>
                        </div>
                    </div>
                    {userIsTrainer &&
                        <button onClick={() => handleOpenTrainerConsole()} className="trainer-btn">Trainer Console</button>
                    }
                </div>
                <button onClick={() => handleLogout()} className="logout-btn">Logout</button>
            </div>
        </div>
    )
}
